<template>
  <div class="app-package-details-modal">
    <dl class="list list--definition list--clean">
      <dt>{{ $t('APP.RELEASES.APK_STATE') }}</dt>
      <dd>{{ getPackageState(packageItem.publishState) }}</dd>

      <dt>{{ $t('APP.RELEASES.APK_VERSION_CODE') }}</dt>
      <dd>{{ packageItem.versionCode }}</dd>

      <dt>{{ $t('APP.RELEASES.APK_VERSION_NAME') }}</dt>
      <dd>{{ packageItem.versionName }}</dd>

      <dt>{{ $t('APP.RELEASES.APK_VERSION_SIZE') }}</dt>
      <dd>{{ getPackageSize(packageItem.totalSize) }}</dd>

      <dt>{{ $t('APP.RELEASES.APK_MIN_SDK_VERSION') }}</dt>
      <dd>{{ packageItem.apiLevel }}</dd>

      <dt>{{ $t('APP.RELEASES.TARGET_SDK') }}</dt>
      <dd>{{ packageItem.targetApiLevel }}</dd>

      <dt>{{ $t('APP.RELEASES.CPU_ARCHITECTURE') }}</dt>
      <dd>{{ packageItem.cpuArchitectures || '-' }}</dd>

      <dt>{{ $t('APP.RELEASES.APK_UPLOAD_DATE') }}</dt>
      <dd>{{ translateDate(packageItem.uploadDate, lang) }}</dd>

      <dt>{{ $t('APP.RELEASES.APK_PUBLISH_DATE') }}</dt>
      <dd>
        <span v-if="packageItem.publishDate">
          {{ translateDate(packageItem.publishDate, lang) }}
        </span>
        <span v-else>—</span>
      </dd>

      <dt>{{ $t('APP.RELEASES.DETAIL_OBB_PACKAGES') }}</dt>
      <dd>
        <ul v-if="expansionFiles.length">
          <li v-for="file in expansionFiles" :key="file.id">
            <a class="link" :href="file.link" target="_blank">
              {{ file.name }}
            </a>
          </li>
        </ul>
        <span v-else>—</span>
      </dd>

      <dt>Splits</dt>
      <dd>
        <ul v-if="packageSplits.length">
          <li v-for="file in packageSplits" :key="file.name">
            <a class="link" :href="file.link" target="_blank">
              {{ file.name }}
            </a>
          </li>
        </ul>
        <span v-else>—</span>
      </dd>
    </dl>

    <div class="app-package-details-modal__footer">
      <ElButton type="primary" @click="$modal.close()">
        {{ $t('CLOSE') }}
      </ElButton>
    </div>
  </div>
</template>

<script>
import bytesToSize from '@/utils/bytesToSize';
import appState from '@/mixins/appState';
import lang from '@/mixins/lang';
import { translateDate } from '@/utils/date';

export default {
  name: 'AppPackageDetailsModal',
  mixins: [appState, lang],
  props: {
    packageItem: {
      type: Object,
      required: true,
    },
    release: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    expansionFiles() {
      const { bundle } = this.release;
      const additionalFiles = this.packageItem.additionalFiles || [];
      const files = [...additionalFiles];

      if (bundle && bundle.bundleLink) {
        files.unshift({
          id: bundle.id,
          name: this.$t('APP.RELEASES.BUNDLE_FILE'),
          link: bundle.bundleLink,
        });
      }

      return files;
    },
    packageSplits() {
      return this.packageItem?.splits || [];
    },
  },
  methods: {
    getPackageSize: bytesToSize,
    translateDate,
  },
};
</script>

<style lang="scss">
.app-package-details-modal {
  width: 100%;

  &__footer {
    margin-top: 2 * $global-margin;
  }
}
</style>
